/**
 * Standardized Date and Time utilities for America/Chicago timezone
 */

const TIMEZONE = 'America/Chicago';
const LOCALE = 'en-US';

/**
 * Returns a new Date object adjusted to Chicago time for display purposes.
 * Note: Actual Date objects are UTC-based, but this helps in getting 
 * "What day is it in Chicago right now?"
 */
export const getChicagoNow = () => {
  const now = new Date();
  // We use this to get the string representation in Chicago, then we could parse it
  // if we need a Date object that "looks" like Chicago time.
  return now;
};

/**
 * Formats a date to MM/DD/YYYY HH:MM AM/PM in Chicago timezone
 */
export const formatDateTime = (date) => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString(LOCALE, {
    timeZone: TIMEZONE,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

/**
 * Formats a date to MM/DD/YYYY in Chicago timezone
 */
export const formatDate = (date) => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString(LOCALE, {
    timeZone: TIMEZONE,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
};

/**
 * Formats a date to HH:MM AM/PM in Chicago timezone
 */
export const formatTime = (date) => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString(LOCALE, {
    timeZone: TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

/**
 * Returns "Today" in Chicago timezone as a Date object (start of day)
 */
export const getChicagoToday = () => {
  const nowStr = new Date().toLocaleString(LOCALE, { timeZone: TIMEZONE });
  const today = new Date(nowStr);
  today.setHours(0, 0, 0, 0);
  return today;
};

/**
 * Returns a YYYY-MM-DDTHH:mm string for Chicago time
 * Useful for <input type="datetime-local">
 */
export const getChicagoISOString = (date = new Date()) => {
  const chicagoStr = date.toLocaleString(LOCALE, {
    timeZone: TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });
  
  // chicagoStr is like "04/17/2026, 13:29"
  const [datePart, timePart] = chicagoStr.split(', ');
  const [mm, dd, yyyy] = datePart.split('/');
  const [hh, min] = timePart.split(':');
  
  return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
};

export default {
  formatDateTime,
  formatDate,
  formatTime,
  getChicagoNow,
  getChicagoToday,
  getChicagoISOString
};
